(function () {
  const root = document.querySelector('[data-bundle]');
  if (!root) return;

  const CFG = window.bundleConfig || {};
  const T = CFG.strings || {};
  const FORMAT = CFG.moneyFormat || 'LE {{amount}}';
  const MIN = parseInt(root.dataset.min, 10) || 3;
  const DISCOUNT = (parseFloat(root.dataset.discount) || 0) / 100;

  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return (tmp.textContent || '').replace(/\s+/g, ' ').trim();
  };

  const money = (cents) => {
    const value = (Number(cents) / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return stripHtml(FORMAT.replace(/\{\{\s*amount[^}]*\}\}/g, value)) || 'LE ' + value;
  };

  const cards = [...root.querySelectorAll('[data-card]')];
  const bar = root.querySelector('[data-bar]');
  const countEl = root.querySelector('[data-count]');
  const wasEl = root.querySelector('[data-was]');
  const nowEl = root.querySelector('[data-now]');
  const saveEl = root.querySelector('[data-save]');
  const addBtn = root.querySelector('[data-add]');
  const addBtnText = root.querySelector('[data-btn-text]');
  const note = root.querySelector('[data-note]');

  // productId -> { variantId, price, title }
  const selected = new Map();

  cards.forEach((card) => {
    const productId = card.dataset.product;
    const sizeWrap = card.querySelector('[data-sizes]');
    const sizeBtns = [...sizeWrap.querySelectorAll('.bundle__size')];
    const priceEl = card.querySelector('[data-card-price]');
    const img = card.querySelector('[data-card-img]');
    const pickBtn = card.querySelector('[data-pick]');
    const pickText = card.querySelector('[data-pick-text]');

    let variantId = null;
    let price = 0;

    const inStock = sizeBtns.filter((b) => !b.disabled);

    const setPickState = () => {
      const isPicked = selected.has(productId);
      card.classList.toggle('is-selected', isPicked);
      pickBtn.classList.toggle('is-picked', isPicked);
      pickBtn.disabled = !variantId;
      pickText.textContent = isPicked
        ? (T.picked || 'SELECTED ✓')
        : (variantId ? (T.pick || 'ADD') : (T.selectSize || 'SELECT A SIZE'));
    };

    const chooseSize = (btn) => {
      if (btn.disabled) return;
      sizeBtns.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      variantId = btn.dataset.variant;
      price = parseInt(btn.dataset.price, 10);
      priceEl.textContent = money(price);
      if (btn.dataset.image && img) img.src = btn.dataset.image;

      // If already selected, update the stored variant in place
      if (selected.has(productId)) {
        selected.set(productId, { variantId, price });
        update();
      }
      setPickState();
    };

    sizeBtns.forEach((b) => b.addEventListener('click', () => chooseSize(b)));

    pickBtn.addEventListener('click', () => {
      if (!variantId) return;
      if (selected.has(productId)) selected.delete(productId);
      else selected.set(productId, { variantId, price });
      setPickState();
      update();
    });

    // Auto-select the only available size
    if (inStock.length === 1) chooseSize(inStock[0]);
    else setPickState();
  });

  function update() {
    const items = [...selected.values()];
    const n = items.length;
    const subtotal = items.reduce((s, it) => s + it.price, 0);
    const qualifies = n >= MIN;

    countEl.textContent = n + (n === 1 ? ' item selected' : ' items selected');

    if (!n) {
      bar.classList.remove('is-visible');
      addBtn.disabled = true;
      nowEl.textContent = '';
      wasEl.hidden = true;
      saveEl.hidden = true;
      note.textContent = T.helper || '';
      addBtnText.textContent = T.button || 'ADD BUNDLE TO CART';
      return;
    }

    bar.classList.add('is-visible');
    addBtn.disabled = false;
    addBtnText.textContent = T.button || 'ADD BUNDLE TO CART';

    if (qualifies) {
      const discounted = Math.round(subtotal * (1 - DISCOUNT));
      wasEl.textContent = money(subtotal);
      wasEl.hidden = false;
      nowEl.textContent = money(discounted);
      saveEl.textContent = 'Save ' + money(subtotal - discounted);
      saveEl.hidden = false;
      note.textContent = T.helper || '';
    } else {
      wasEl.hidden = true;
      saveEl.hidden = true;
      nowEl.textContent = money(subtotal);
      const left = MIN - n;
      note.textContent = 'Add ' + left + ' more item' + (left === 1 ? '' : 's') + ' to unlock ' +
        Math.round(DISCOUNT * 100) + '% off.';
    }
  }

  addBtn.addEventListener('click', async () => {
    const items = [...selected.values()];
    if (!items.length) return;

    addBtn.disabled = true;
    addBtnText.textContent = T.adding || 'ADDING…';

    const stamp = Date.now().toString(36);
    const payload = items.map((it) => ({
      id: Number(it.variantId),
      quantity: 1,
      properties: items.length >= MIN ? { _bundle: stamp } : {}
    }));

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: payload })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart.');

      addBtnText.textContent = T.added || 'ADDED ✓';
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));

      const drawer = document.querySelector('cart-drawer, cart-notification, #CartDrawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        setTimeout(() => {
          selected.clear();
          cards.forEach((c) => {
            c.classList.remove('is-selected');
            const pb = c.querySelector('[data-pick]');
            pb.classList.remove('is-picked');
            c.querySelector('[data-pick-text]').textContent = T.pick || 'ADD';
          });
          update();
        }, 1800);
      } else {
        setTimeout(() => { window.location.href = '/cart'; }, 400);
      }
    } catch (err) {
      note.textContent = err.message;
      addBtnText.textContent = T.button || 'ADD BUNDLE TO CART';
      addBtn.disabled = false;
    }
  });

  update();
})();